// Estilos compartilhados entre os 4 steps. Mesma paleta usada no Login.
// Cores hardcoded de propósito (sem theme tokens — feedback do usuário).

export const styles = {
    // ---------- Layout principal ----------
    pageContainer: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#FFFFFF',
        fontFamily: "'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
        color: '#0F172A',
    },
    registerSection: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem 2rem',
        overflowY: 'auto',
    },
    formContainer: {
        width: '100%',
        maxWidth: '480px',
    },

    // ---------- Tipografia ----------
    title: {
        fontSize: '1.875rem',
        fontWeight: 700,
        color: '#0F172A',
        marginBottom: '0.5rem',
        letterSpacing: '-0.02em',
    },
    subtitle: {
        color: '#64748B',
        marginBottom: '2rem',
        fontSize: '0.95rem',
    },

    // ---------- Stepper ----------
    stepper: {
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '2rem',
    },
    stepperBar: (active) => ({
        flex: 1,
        height: '4px',
        borderRadius: '2px',
        backgroundColor: active ? '#059669' : '#E2E8F0',
        transition: 'background-color 0.2s ease',
    }),

    // ---------- Inputs ----------
    inputGroup: { marginBottom: '1.1rem' },
    label: {
        display: 'block',
        fontSize: '0.8rem',
        fontWeight: 600,
        color: '#334155',
        marginBottom: '0.4rem',
        letterSpacing: '0.01em',
    },
    inputWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    inputIcon: {
        position: 'absolute',
        left: '0.875rem',
        color: '#94A3B8',
        pointerEvents: 'none',
        display: 'grid',
        placeItems: 'center',
    },
    input: (hasError, hasIcon = true) => ({
        width: '100%',
        padding: hasIcon ? '0.75rem 1rem 0.75rem 2.75rem' : '0.75rem 1rem',
        border: `1.5px solid ${hasError ? '#F43F5E' : '#E2E8F0'}`,
        borderRadius: '10px',
        fontSize: '0.95rem',
        color: '#0F172A',
        backgroundColor: '#FFFFFF',
        outline: 'none',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
    }),
    fieldError: {
        marginTop: '0.4rem',
        fontSize: '0.8rem',
        color: '#E11D48',
        display: 'flex',
        alignItems: 'center',
        gap: '0.3rem',
    },

    // ---------- Botões ----------
    signUpButton: {
        width: '100%',
        padding: '0.85rem',
        background: 'linear-gradient(135deg, #059669 0%, #10B981 100%)',
        color: '#fff',
        border: 'none',
        borderRadius: '10px',
        fontSize: '0.95rem',
        fontWeight: 600,
        cursor: 'pointer',
        marginTop: '0.75rem',
        transition: 'transform 0.15s, box-shadow 0.15s, opacity 0.15s',
        boxShadow: '0 4px 12px -2px rgba(5, 150, 105, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        fontFamily: 'inherit',
    },
    secondaryButton: {
        width: '100%',
        padding: '0.7rem',
        backgroundColor: 'transparent',
        color: '#64748B',
        border: '1.5px solid #E2E8F0',
        borderRadius: '10px',
        fontSize: '0.875rem',
        fontWeight: 500,
        cursor: 'pointer',
        marginTop: '0.5rem',
        transition: 'background-color 0.15s, border-color 0.15s',
        fontFamily: 'inherit',
    },

    // ---------- Step 3: produto ----------
    productCard: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 1.25rem',
        border: '1.5px solid #E2E8F0',
        borderRadius: '12px',
        marginBottom: '0.6rem',
        cursor: 'pointer',
        transition: 'all 0.15s',
        backgroundColor: '#FFFFFF',
        color: '#0F172A',
        fontSize: '0.9rem',
    },
    productCardSelected: {
        borderColor: '#059669',
        backgroundColor: '#ECFDF5',
        boxShadow: '0 0 0 3px rgba(5, 150, 105, 0.1)',
    },

    // ---------- Step 4: Pix ----------
    pixContainer: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    pixQrCode: {
        width: '200px',
        height: '200px',
        margin: '0',
        display: 'block',
    },
    copyInput: {
        width: '100%',
        padding: '0.6rem',
        backgroundColor: '#F1F5F9',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        fontSize: '0.75rem',
        color: '#475569',
        marginBottom: '0.5rem',
        textAlign: 'center',
        fontFamily: "'JetBrains Mono', monospace",
        resize: 'none',
        boxSizing: 'border-box',
    },

    // ---------- Ilustração (direita) ----------
    illustrationSection: {
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #059669 0%, #0D9488 50%, #10B981 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem',
        color: '#fff',
    },
    placeholderImage: {
        position: 'relative',
        zIndex: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '2.5rem',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        color: '#fff',
        boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.2)',
    },
    floatingIcons: [
        { icon: '🎓', top: '12%', left: '10%', fontSize: '3rem' },
        { icon: '💳', bottom: '18%', right: '12%', fontSize: '2.5rem' },
        { icon: '📱', top: '22%', right: '15%', fontSize: '2rem' },
    ],
    placeholderIcon: {
        position: 'absolute',
        opacity: 0.35,
        zIndex: 1,
    },

    // ---------- Link login ----------
    signInRow: {
        textAlign: 'center',
        fontSize: '0.875rem',
        color: '#64748B',
    },
    signInLink: {
        color: '#059669',
        textDecoration: 'none',
        fontWeight: 600,
        marginLeft: '0.25rem',
    },
};
